import { Component, Input, OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { NOTAM } from '../models/notam.model';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { TfrDetailsComponent } from '../tfr-details/tfr-details.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { AuthService } from '../../auth/auth/auth.service';

@Component({
  selector: 'app-tfrs',
  templateUrl: './tfrs.component.html',
  styleUrls: ['./tfrs.component.scss']
})
export class TfrsComponent implements OnInit {
  @Input() airport: Airport;
  isLoggedIn = false;
  isMember = false;


  getActiveTFRs(): NOTAM[] {
    const activeTFRs: NOTAM[] = [];
    this.airport.tfrs.forEach( (notam) => {
      if (this.getTFRStatus(notam) === 'ACTIVE') {
        activeTFRs.push(notam);
      }
    });
    activeTFRs.sort((a, b) => a.effectiveDate.getTime() - b.effectiveDate.getTime());
    return activeTFRs;
  }

  getScheduledTFRs(): NOTAM[] {
    const scheduledTFRs: NOTAM[] = [];
    this.airport.tfrs.forEach( (notam) => {
      if (this.getTFRStatus(notam) === 'SCHEDULED') {
        scheduledTFRs.push(notam);
      }
    });
    scheduledTFRs.sort((a, b) => a.effectiveDate.getTime() - b.effectiveDate.getTime());
    return scheduledTFRs;
  }

  getTFRs(): NOTAM[] {
    const results = [ ...this.getActiveTFRs(), ...this.getScheduledTFRs()];
    return results;
  }

  constructor(private _dialog: MatDialog,
              private _businessManagerService: BusinessManagerService,
              private _auth: AuthService) { }

  async ngOnInit() {
    if (this._auth.authenticated && this._auth.endUser) {
      this.isLoggedIn = true;
      this.isMember = await this._businessManagerService.isMember();
    }
  }

  getTFRStatus(tfr: NOTAM): string {
    const currentDate = new Date();
    if (tfr.expirationDate) {
      if (tfr.effectiveDate.getTime() < currentDate.getTime() && currentDate.getTime() < tfr.expirationDate.getTime()) {
        return 'ACTIVE';
      } else if (tfr.effectiveDate.getTime() > currentDate.getTime() && currentDate.getTime() < tfr.expirationDate.getTime()) {
        return 'SCHEDULED';
      } else {
        return 'EXPIRED';
      }
    } else {
      if (tfr.effectiveDate.getTime() < currentDate.getTime()) {
        return 'ACTIVE';
      } else if (tfr.effectiveDate.getTime() > currentDate.getTime()) {
        return 'SCHEDULED';
      } else {
        return 'ERROR';
      }
    }
  }

  showTFRDetails(tfr: NOTAM) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      tfr: tfr
    };
    const dialogRef = this._dialog.open(TfrDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
    });
  }
}
